let lastScrollTop = 0;

window.addEventListener("scroll", function () {
    const sectionHeader = document.getElementsByClassName("section-header")[0];
    const sectionSidebar = document.getElementsByClassName("ysw-facets-container")[0];
    const navbarHeight = sectionHeader.offsetHeight;
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
    if (scrollTop > navbarHeight && scrollTop < lastScrollTop) {
      sectionSidebar.style.top = navbarHeight + "px";
    } else {
      sectionSidebar.style.top = "0px";
    }

    lastScrollTop = scrollTop;
  });